<template>
  <div>
    <div class="bg-dark m-b-30">
      <div class="container">
        <div class="row p-b-60 p-t-60">
          <div class="col-md-6 text-white p-b-30">
            <div class="media">
              <div class="avatar avatar mr-3">
                <div class="avatar-title bg-success rounded-circle mdi mdi-view-list"></div>
              </div>
              <div class="media-body">
                <h3 class="p-t-10">{{ pageTitle }}</h3>
                <p class="opacity-75"></p>
              </div>
            </div>
          </div>
          <div class="col-md-6 text-center m-b-30 ml-auto">
            <div class="text-md-right">
              <router-link v-can="'modifier.read'" is="el-button" :to="{name: 'modifiers'}" icon="el-icon-s-order" type="primary">
                {{ $t('modifier.button.all') }}
              </router-link>
              <el-button v-can="'modifier.create'" @click="showCreateDialog" icon="el-icon-plus"  type="success">
                {{ $t('modifier.button.create') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <create-modifier @close="closeCreateDialog" :display="displayCreateDialog" @created="modifierCreated"></create-modifier>
    <transition name="slide-fade">
      <router-view @parent-title="updateTitle"/>
    </transition>
  </div>
</template>

<script>
import CreateModifier from './Modal/Create'
export default {
  name: 'Modifier',
  components: { CreateModifier },
  data () {
    return {
      pageTitle: '',
      displayCreateDialog: false
    }
  },
  methods: {
    updateTitle (title) {
      this.pageTitle = title
    },
    showCreateDialog () {
      this.displayCreateDialog = true
    },
    closeCreateDialog () {
      this.displayCreateDialog = false
    },
    modifierCreated (data) {
      this.$emit('new-modifier', data)
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('modifier.title.modifier'))
  }
}
</script>

<style scoped>

</style>
